export default __webpack_public_path__ + "static/media/led2.860d868a.png";